import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';

export const SummaryHeader = styled(FlexView)`
  padding: 16px 0;
  border-bottom: 1px solid ${COLORS.GREY_2};
  margin-bottom: 8px;
`;

export const DetectionVerdictBadge = styled(FlexView)`
  padding: 6px 16px;
  border-radius: 6px;
  background: ${({ bg }) => bg};
`;

export const NextButton = styled.button`
  margin-top: 20px;
  padding: 10px 32px;
  min-width: 240px;
  cursor: pointer;
  border: 1px solid transparent;
  background: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  transition: opacity 0.15s ease;
  display: flex;
  justify-content: center;
  width: fit-content;
  white-space: nowrap;
  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const NextButtonText = styled(Text)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TableHeaderRow = styled(FlexView)`
  border-bottom: 1px solid ${COLORS.GREY_2};
  gap: 16px;
`;
